import { createSelector } from "reselect";
import { isEmpty, forIn, isNull } from "lodash";

const defaultUserProfile = {
  diet: null,
  smoke: null,
  drink: null
};
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const userProfile = state.user.profile;
  //get all static data
  const { data } = state;
  //if any of the static data is empty return the default value
  if (isEmpty(data.diet) || isEmpty(data.habitType)) {
    return defaultUserProfile;
  }
  //if preference is empty return the default value
  if (isEmpty(userProfile)) {
    return defaultUserProfile;
  }
  //format the preference and return it
  try {
    let object = {};
    forIn(userProfile, (value, key) => {
      if (key === "diet") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "smoke" || key === "drink") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data.habitType[value]) {
            object[key] = {
              label: data.habitType[value].label,
              value: data.habitType[value].value,
              description: data.habitType[value].description
            };
          }
        }
      } else {
        //do nothing
      }
    });
    return object;
  } catch (error) {
    return defaultUserProfile;
  }
};
//VERIFY IF THE JWT IS SET
const getMyUserHabitProfile = createSelector(
  getData,
  userProfile => userProfile
);
export default getMyUserHabitProfile;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyUserHabitProfile.js